import Main from '@/components/main'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

const rs = [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录',
      hideInMenu: true
    },
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/',
    name: '_home',
    redirect: '/home',
    component: Main,
    meta: {
      // hideInMenu: true,
      keepAlive: true,
      notCache: false
    },
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          // hideInMenu: true,
          title: '首页',
          notCache: false,
          keepAlive: true,
          icon: 'md-home'
        },
        component: () => import('@/view/home/index.vue')
      }
    ]
  }
]
const mainRouer = [
  {
    path: '/_data',
    name: '_data',
    redirect: '/data',
    component: Main,
    meta: {
      // hideInMenu: true,
      title: '投放管理',
      keepAlive: true,
      icon: 'md-home'
      // notCache: false
    },
    children: [
      {
        path: '/data',
        name: 'dataMap',
        meta: {
          // hideInMenu: true,
          title: '数据总览',
          // notCache: false,
          keepAlive: true
        },
        component: () => import('@/view/single-page/home/home.vue')
      },
      {
        path: '/data-color',
        name: 'dataColor',
        meta: {
          // hideInMenu: true,
          title: '数据总览（染色）',
          notCache: false,
          keepAlive: true
        },
        component: () => import('@/view/data/homeColor.vue')
      },
      {
        path: '/data-new',
        name: 'dataNew',
        meta: {
          // hideInMenu: true,
          title: '新数据总览',
          notCache: false,
          keepAlive: true
        },
        component: () => import('@/view/dataNew/index.vue')
      },
      {
        path: '/playData',
        name: 'playData',
        meta: {
          // hideInMenu: true,
          title: '短剧数据',
          // notCache: true,
          notCache: false,
          keepAlive: true
        },
        component: () => import('@/view/playData/index.vue')
      },
      {
        path: '/playData-color',
        name: 'playDataColor',
        meta: {
          // hideInMenu: true,
          title: '短剧数据（染色）',
          // notCache: true,
          notCache: false,
          keepAlive: true
        },
        component: () => import('@/view/playDataColor/index.vue')
      },
      {
        path: '/playDataNew',
        name: 'playDataNew',
        meta: {
          // hideInMenu: true,
          title: '新短剧数据',
          // notCache: true,
          notCache: false,
          keepAlive: true
        },
        component: () => import('@/view/playDataNew/index.vue')
      },
      {
        path: '/playData-color-new',
        name: 'playDataColorNew',
        meta: {
          // hideInMenu: true,
          title: '新短剧数据（染色）',
          // notCache: true,
          notCache: false,
          keepAlive: true
        },
        component: () => import('@/view/playDataColorNew/index.vue')
      },
      {
        path: '/play-new',
        name: 'PlayNewData',
        meta: {
          // hideInMenu: true,
          title: '短剧报表',
          // notCache: true,
          notCache: false,
          keepAlive: true
        },
        component: () => import('@/view/launch/play/index.vue')
      },
      {
        path: '/pitcher',
        name: 'pitcher',
        meta: {
          // hideInMenu: true,
          title: '投手报表',
          // notCache: true,
          notCache: false,
          keepAlive: true
        },
        component: () => import('@/view/launch/pitcherPage/index.vue')
      },
      {
        path: '/pitcher-color',
        name: 'pitcherColor',
        meta: {
          // hideInMenu: true,
          title: '投手报表（染色）',
          // notCache: true,
          notCache: false,
          keepAlive: true
        },
        component: () => import('@/view/launch/pitcherPageColor/index.vue')
      },
      {
        path: '/pitcher-new',
        name: 'PitcherNew',
        meta: {
          // hideInMenu: true,
          title: '新投手报表',
          // notCache: true,
          notCache: false,
          keepAlive: true
        },
        component: () => import('@/view/launch/pitcher/index.vue')
      },
      {
        path: '/landingPage',
        name: 'landingPage',
        meta: {
          // hideInMenu: true,
          title: '落地页配置',
          notCache: true
        },
        component: () => import('@/view/launch/landingPage/index.vue')
      },
      {
        path: '/landingTemp',
        name: 'landingTemp',
        meta: {
          // hideInMenu: true,
          title: '充值模板配置',
          notCache: true
        },
        component: () => import('@/view/launch/landingTemp/index.vue')
      }
    ]
  },

  {
    path: '/main',
    name: 'main',
    redirect: '/play',
    component: Main,
    meta: {
      // hideInMenu: true,
      // hideInBread: true,
      title: '内容管理',
      icon: 'ios-cube',
      notCache: false,
      keepAlive: true
    },
    children: [
      {
        path: '/play',
        name: 'PlayMain',
        meta: {
          // hideInMenu: true,
          notCache: false,
          keepAlive: true,
          title: '短剧管理'
        },
        component: () => import('@/view/play/index.vue')
      },
      {
        path: '/primary',
        name: 'primary',
        meta: {
          // hideInMenu: true,
          title: '主剧管理',
          notCache: true
        },
        component: () => import('@/view/primaryPlay/index.vue')
      },
      {
        path: '/episode',
        name: 'episode',
        meta: {
          // hideInMenu: true,
          title: '剧集管理',
          notCache: true
        },
        component: () => import('@/view/episode/index.vue')
      },
      {
        path: '/novel',
        name: 'novel',
        meta: {
          // hideInMenu: true,
          title: '小说管理',
          notCache: true
        },
        component: () => import('@/view/novel/index.vue')
      }
    ]
  },
  {
    path: '/server',
    name: 'server',
    redirect: '/banner',
    component: Main,
    meta: {
      // hideInMenu: true,
      // hideInBread: true,
      title: 'app配置',
      icon: 'ios-apps',
      notCache: true
    },
    children: [
      {
        path: '/banner',
        name: 'banner',
        meta: {
          // hideInMenu: true,
          title: 'banner管理',
          notCache: true
        },
        component: () => import('@/view/banner/index.vue')
      },
      {
        path: '/activity',
        name: 'activity',
        meta: {
          // hideInMenu: true,
          title: '任务配置',
          notCache: true
        },
        component: () => import('@/view/activity/index.vue')
      },
      {
        path: '/activity-score-audit',
        name: 'activityScoreAudit',
        meta: {
          title: '评分活动审核',
          notCache: true
        },
        component: () => import('@/view/activity/scoreAudit.vue')
      },
      {
        path: '/activity-config',
        name: 'activityConfig',
        meta: {
          title: '活动配置',
          notCache: true
        },
        component: () => import('@/view/activityConfig/index.vue')
      },
      {
        path: '/push',
        name: 'push',
        meta: {
          // hideInMenu: true,
          title: '推送配置',
          notCache: true
        },
        component: () => import('@/view/pushMsg/index.vue')
      },
      {
        path: '/theater',
        name: 'theater',
        meta: {
          // hideInMenu: true,
          title: '剧场管理',
          notCache: true
        },
        component: () => import('@/view/theater/index.vue')
      },
      {
        path: '/search',
        name: 'search',
        meta: {
          // hideInMenu: true,
          title: '搜索页管理',
          notCache: true
        },
        component: () => import('@/view/search/index.vue')
      },
      {
        path: '/recommend',
        name: 'recommend',
        meta: {
          // hideInMenu: true,
          title: '推荐配置',
          notCache: true
        },
        component: () => import('@/view/recommend/index.vue')
      },
      {
        path: '/track',
        name: 'track',
        meta: {
          // hideInMenu: true,
          title: '追剧配置',
          notCache: true
        },
        component: () => import('@/view/track/index.vue')
      },
      {
        path: '/global-setting',
        name: 'global',
        meta: {
          // hideInMenu: true,
          title: '全局配置',
          notCache: true
        },
        component: () => import('@/view/global/index.vue')
      },
      {
        path: '/version',
        name: 'version',
        meta: {
          // hideInMenu: true,
          title: '版本号配置',
          notCache: true
        },
        component: () => import('@/view/version/index.vue')
      },
      {
        path: '/notification',
        name: 'notification',
        meta: {
          // hideInMenu: true,
          title: '弹窗配置',
          notCache: true
        },
        component: () => import('@/view/notification/index.vue')
      },
      {
        path: '/notification-test',
        name: 'notificationTest',
        meta: {
          // hideInMenu: true,
          title: '弹窗测试',
          notCache: true
        },
        component: () => import('@/view/notification/TestModal.vue')
      },
      {
        path: '/notification-crowd',
        name: 'notificationCrowd',
        meta: {
          // hideInMenu: true,
          title: '人群包设置',
          notCache: true
        },
        component: () => import('@/view/notification/crowd/index.vue')
      },
      {
        path: '/notification-push',
        name: 'notificationPush',
        meta: {
          // hideInMenu: true,
          title: '活动推送设置',
          notCache: true
        },
        component: () => import('@/view/notification/push/index.vue')
      }
    ]
  },
  {
    path: '/tags',
    name: 'tags',
    redirect: '/tag',
    component: Main,
    meta: {
      hideInBread: true,
      title: '标签管理',
      icon: 'ios-pricetags-outline',
      notCache: true,
      showAlways: true
    },
    children: [
      {
        path: '/tag',
        name: 'tag',
        meta: {
          // hideInMenu: true,
          title: '标签管理',
          notCache: true
        },
        component: () => import('@/view/tag/index.vue')
      },
      {
        path: '/channel',
        name: 'channel',
        meta: {
          // hideInMenu: true,
          title: '分类管理',
          notCache: true
        },
        component: () => import('@/view/channel/index.vue')
      },
      {
        path: '/lang',
        name: 'lang',
        meta: {
          // hideInMenu: true,
          title: '语言管理',
          notCache: true
        },
        component: () => import('@/view/lang/index.vue')
      }
    ]
  },
  {
    path: '/advertise',
    name: 'advertise',
    redirect: '/advertise',
    component: Main,
    meta: {
      hideInBread: true,
      title: '广告配置',
      icon: 'ios-pricetags-outline',
      notCache: true,
      showAlways: true
    },
    children: [
      {
        path: '/advertise-strategy',
        name: 'advertiseStrategy',
        meta: {
          title: '广告策略配置',
          notCache: true
        },
        component: () => import('@/view/advertise/index.vue')
      }
    ]
  },
  {
    path: '/fee',
    name: 'fee',
    redirect: '/pay',
    component: Main,
    meta: {
      // hideInMenu: true,
      // hideInBread: true,
      title: '付费项管理',
      icon: 'ios-paper',
      notCache: true
    },
    children: [
      {
        path: '/pay',
        name: 'pay',
        meta: {
          // hideInMenu: true,
          title: '付费项配置',
          icon: 'ios-paper',
          notCache: true
        },
        component: () => import('@/view/fee/index.vue')
      },
      {
        path: '/pay-last',
        name: 'payLast',
        meta: {
          // hideInMenu: true,
          title: '付费项配置（旧)',
          icon: 'ios-paper',
          notCache: true
        },
        component: () => import('@/view/fee/last/index.vue')
      },
      {
        path: '/rate',
        name: 'rate',
        meta: {
          // hideInMenu: true,
          title: '汇率维护',
          icon: 'ios-paper',
          notCache: true
        },
        component: () => import('@/view/fee/rate/index.vue')
      },
      {
        path: '/fee-recharge-template',
        name: 'feeRechargeTemplate',
        meta: {
          // hideInMenu: true,
          title: '充值模板配置',
          icon: 'ios-paper',
          notCache: true
        },
        component: () => import('@/view/fee/rechargeTemplate/index.vue')
      }
    ]
  },
  {
    path: '/thirdParty',
    name: 'thirdParty',
    redirect: '/thirdParty',
    component: Main,
    meta: {
      // hideInMenu: true,
      // hideInBread: true,
      title: '三方支付管理',
      icon: 'ios-paper',
      notCache: true
    },
    children: [
      {
        path: '/thirdParty-switch',
        name: 'thirdPartySwitch',
        meta: {
          // hideInMenu: true,
          title: '三方支付开关',
          notCache: true
        },
        component: () => import('@/view/thirdParty/switch.vue')
      },
      {
        path: '/thirdParty-config',
        name: 'thirdPartyConfig',
        meta: {
          // hideInMenu: true,
          title: '支付方式设置',
          notCache: true
        },
        component: () => import('@/view/thirdParty/config.vue')
      }
    ]
  },
  {
    path: '/abTest',
    name: 'abTest',
    redirect: '/abTest',
    component: Main,
    meta: {
      // hideInMenu: true,
      // hideInBread: true,
      title: 'ab测试',
      icon: 'ios-bulb',
      notCache: true
    },
    children: [
      {
        path: '/abTest',
        name: 'abTest',
        meta: {
          // hideInMenu: true,
          title: 'ab测试',
          icon: 'ios-bulb',
          hideInBread: true,
          notCache: true
        },
        component: () => import('@/view/abTest/index.vue')
      },
      {
        path: '/abTest/add',
        name: 'abTestAdd',
        meta: {
          hideInMenu: true,
          title: '新增实验',
          notCache: true
        },
        component: () => import('@/view/abTest/components/AddExperiment.vue')
      }
    ]
  },
  {
    path: '/server-web',
    name: 'webServer',
    redirect: '/web-banner',
    component: Main,
    meta: {
      // hideInMenu: true,
      // hideInBread: true,
      showAlways: true,
      title: 'web配置',
      icon: 'md-desktop',
      notCache: true
    },
    children: [
      {
        path: '/web-banner',
        name: 'webBanner',
        meta: {
          // hideInMenu: true,
          title: 'banner管理',
          notCache: true
        },
        component: () => import('@/view/banner-web/index.vue')
      }
    ]
  },
  {
    path: '/complaint-center',
    name: 'complaintCenter',
    redirect: '/complaint-center-order',
    component: Main,
    meta: {
      title: '客诉中心',
      icon: 'md-headset',
      notCache: true,
      showAlways: true
    },
    children: [
      {
        path: '/complaint-center-order',
        name: 'complaintCenterOrder',
        meta: {
          title: '订单管理',
          notCache: true
        },
        component: () => import('@/view/customer-service/order/index.vue')
      },
      {
        path: '/complaint-center-after-sales',
        name: 'complaintCenterAfterSales',
        meta: {
          title: '售后管理',
          notCache: true
        },
        component: () =>
          import('@/view/customer-service/after-sales/index.vue')
      },
      {
        path: '/complaint-center-platform-query',
        name: 'complaintCenterPlatformQuery',
        meta: {
          title: '支付平台查询',
          notCache: true
        },
        component: () =>
          import('@/view/customer-service/platform-query/index.vue')
      }
    ]
  },
  {
    path: '/user',
    name: 'user',
    component: Main,
    meta: {
      hideInBread: true,
      notCache: true,
      title: '用户管理',
      icon: 'md-person'
    },
    children: [
      {
        path: '/user-info',
        name: 'userInfo',
        meta: {
          // hideInMenu: true,
          title: '用户信息管理',
          notCache: true
        },
        component: () => import('@/view/user/index.vue')
      },
      {
        path: '/user-order',
        name: 'userOrder',
        meta: {
          // hideInMenu: true,
          title: '用户订单管理',
          notCache: true
        },
        component: () => import('@/view/user/order.vue')
      },
      {
        path: '/finance-order',
        name: 'financeOrder',
        meta: {
          // hideInMenu: true,
          title: '财务订单管理',
          notCache: true
        },
        component: () => import('@/view/user/finaceOrder.vue')
      },
      {
        path: '/finance',
        name: 'finance',
        meta: {
          // hideInMenu: true,
          title: '财务报表',
          notCache: true
        },
        component: () => import('@/view/finance/index.vue')
      },
    ]
  },

  {
    path: '/system',
    name: 'system',
    redirect: '/dictionary',
    component: Main,
    meta: {
      // hideInMenu: true,
      // hideInBread: true,
      icon: 'md-settings',
      title: '系统配置',
      notCache: true
    },
    children: [
      // {
      //   path: '/page',
      //   name: 'buryingPoint',
      //   meta: {
      //     // hideInMenu: true,
      //     title: '页面埋点',
      //     notCache: true
      //   },
      //   component: () => import('@/view/buryingPoint/index.vue')
      // },
      {
        path: '/dictionary',
        name: 'dictionary',
        meta: {
          // hideInMenu: true,
          title: '字典管理',
          notCache: true
        },
        component: () => import('@/view/dictionary/index.vue')
      },
      {
        path: '/role',
        name: 'role',
        meta: {
          // hideInMenu: true,
          title: '角色管理',
          notCache: true
        },
        component: () => import('@/view/role/index.vue')
      },
      {
        path: '/permission',
        name: 'permission',
        meta: {
          // hideInMenu: true,
          title: '权限管理',
          notCache: true
        },
        component: () => import('@/view/permission/index.vue')
      },
      {
        path: '/menu',
        name: 'menu',
        meta: {
          // hideInMenu: true,
          title: '菜单管理',
          notCache: true
        },
        component: () => import('@/view/menu/index.vue')
      }

    ]
  },
  {
    path: '/tiktok',
    name: 'tiktokVideo',
    meta: {
      icon: 'md-settings',
      title: 'Tiktok小程序管理',
      notCache: true
    },
    redirect: '/short-video',
    component: Main,
    children: [
      {
        path: '/short-review',
        name: 'shortReview',
        meta: {
          title: '短剧审核管理',
          notCache: true
        },
        component: () => import('@/view/short-review/index.vue')
      },
      {
        path: '/short-video',
        name: 'shortVideo',
        meta: {
          title: '短剧管理',
          notCache: true
        },
        component: () => import('@/view/short-video/index.vue')
      },
      {
        path: '/theater-list',
        name: 'theaterList',
        meta: {
          title: '剧场配置',
          notCache: true
        },
        component: () => import('@/view/theater-list/index.vue')
      },
      {
        path: '/for-u',
        name: 'forU',
        meta: {
          title: 'For U配置',
          notCache: true
        },
        component: () => import('@/view/for-u/index.vue')
      },
      {
        path: '/mini-program',
        name: 'miniProgram',
        meta: {
          title: '小程序管理',
          notCache: true
        },
        component: () => import('@/view/mini-program/index.vue')
      }
    ]
  }
]

const errorRouter = [
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/500.vue')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/404.vue')
  }
]

export default [...rs, ...mainRouer, ...errorRouter]

export { rs, mainRouer, errorRouter }
